<template>
  <div class="maskBox">
    <div class="confirmWithdraw">
      <div class="title">{{$t('lang.cashWheel.earnMoreMoney')}}</div>
      <div class="tip">{{$t('lang.cashWheel.GoPlayLuck')}}</div>
      <div class="btnBox">
        <div class="Btn" @click="close()">{{$t('lang.cashWheel.go')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-earnMoreMoney',
  data () {
    return {}
  },
  methods: {
    close () {
      this.$emit('closeModalEarnMoreMoney')
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.confirmWithdraw{
  background-color: rgba(24,24,24);
  border-radius: 2.22vw;
  width: 82.23vw;
  height: 66.94vw;
  color: #D9D9D9;
  font-weight: 700;
  font-size: 5.27vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8vw;
  animation: expandBox 0.2s ease-out forwards;
  .title{
    width: 56.38vw;
    text-align: center;
  }
  .tip{
    color: rgb(109,109,109);
    font-size: 4.44vw;
    font-weight: 500;
    position: relative;
    top: -3.5vw;
  }
  .btnBox{
    display: flex;
    flex-direction: column;
    gap: 3vw;
    .Btn{
      width: 65.913vw;
      height: 10.833vw;
      background-color: #F1DAB0;
      border-radius: 1.5vw;
      color: #000000;
      font-size: 4.44vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .BtnBox{
      width: 65.913vw;
      height: 10.833vw;
      background-color: #F1DAB0;
      border-radius: 1.5vw;
      color: #F1DAB0;
      font-size: 4.44vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.3vw;
      .Btn2{
        height: 100%;
        width: 100%;
        background-color: #181818;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1.5vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-earnMoreMoney.vue